import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { isEmpty,isUndefined } from 'lodash';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({accountsData,auth}) {
  const { Userlista,MyOfficeType } = accountsData;
  const { authUser } = auth;
  return {
      Userlista,authUser,MyOfficeType
  };
}

function mapDispatchToProps(dispatch) {
    return {

    };
}

class SelectMedArbetare extends Component {
    state={
      ansvarig:this.props.Ansvarig,
      disabled:isUndefined(this.props.disabled)?false:this.props.disabled
    }
    componentDidUpdate=()=>{
      if(this.state.ansvarig !== this.props.Ansvarig){
        this.setState({
          ansvarig:this.props.Ansvarig,
          disabled:isUndefined(this.props.disabled)?false:this.props.disabled
        })
      }
    }
    onChangeHandle=(e)=>{
      this.setState({
        ansvarig:e.target.value
      })
      this.props.onchangeHanelansvarig(e.target.value)
    }
    
    render() {
      return (
            <div>
              <TextField
              variant="outlined"
              fullWidth
              label={isUndefined(this.props.MoteBokare)?<IntlMessages id="appKontoModule.Owner"/>:<IntlMessages id="Booked.by"/>}
              size="small"
              name="Ansvarig"
              disabled={this.state.disabled}
              select
              value={this.state.ansvarig}
              SelectProps={{native: true,}}
              InputLabelProps={{shrink: true,}}
              onChange={this.onChangeHandle}
            >
              <option key={0} disabled value={0}><IntlMessages id="Choose"/></option>
              {      
              !isUndefined(this.props.MoteBokare)?
              !isEmpty(this.props.Userlista.filter(item=>{return isUndefined(this.props.allUsers)?!isEmpty(item.UserEmail) && parseInt(item.IamGhost) === 0:true}))?
              !isEmpty(this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail) && parseInt(item.IamGhost) === 0 && parseInt(item.Role) === 4}))?
              <>
              {
                this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail) && parseInt(item.IamGhost) === 0 && parseInt(item.Role) === 4})
                .map((option) => (
                  <option key={option.id} value={option.id} disabled={isEmpty(option.UserEmail)}>
                    {option.FirstName} {option.LastName}
                  </option>
                ))
              }
              {
                isEmpty(this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail) && parseInt(item.IamGhost) === 0 && parseInt(item.Role) === 4 && parseInt(item.id) === parseInt(this.props.Ansvarig)}))?
                this.props.Userlista.filter(item=>{return parseInt(item.id) === parseInt(this.props.Ansvarig)})
                .map(option=>(
                <option key={option.id} value={option.id} disabled={isEmpty(option.UserEmail)}>
                {option.FirstName} {option.LastName}
              </option>
              ))
                :""
              }
              </>
              :
              this.props.Userlista.filter(item=>{return parseInt(item.id) === parseInt(this.props.Ansvarig)})
              .map(option=>(
                <option key={option.id} value={option.id} disabled={isEmpty(option.UserEmail)}>
                {option.FirstName} {option.LastName}
              </option>
              ))
              :
              this.props.Userlista.filter(item=>{return parseInt(item.id) === parseInt(this.props.Ansvarig)})
              .map(option=>(
                <option key={option.id} value={option.id} disabled={isEmpty(option.UserEmail)}>
                {option.FirstName} {option.LastName}
              </option>
              ))
              :
              !isEmpty(this.props.Userlista.filter(item=>{return isUndefined(this.props.allUsers)?!isEmpty(item.UserEmail) && parseInt(item.IamGhost) === 0:true}))?
 parseInt(this.props.authUser.user_role) > 1?
 parseInt(this.props.authUser.user_FilterAllaKalendar) === 0?
 parseInt(this.props.authUser.user_OfficeId) > 0?
 parseInt(this.props.MyOfficeType) ===2?
 this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail) && parseInt(item.IamGhost) === 0})
          .filter(item=>{return item.OfficeId ===this.props.authUser.user_OfficeId })
          .map((option) => (
            <option key={option.id} value={option.id} disabled={isEmpty(option.UserEmail)}>
              {option.FirstName} {option.LastName}
            </option>
            ))
          :
          this.props.Userlista
          .filter(item=>{return isUndefined(this.props.allUsers)?!isEmpty(item.UserEmail) && parseInt(item.IamGhost) === 0:true})
          .map((option) => (
            <option key={option.id} value={option.id} disabled={isEmpty(option.UserEmail)}>
              {option.FirstName} {option.LastName}
            </option>             
          ))
          :
          this.props.Userlista
          .filter(item=>{return isUndefined(this.props.allUsers)?!isEmpty(item.UserEmail) && parseInt(item.IamGhost) === 0:true})
          .map((option) => (
            <option key={option.id} value={option.id} disabled={isEmpty(option.UserEmail)}>
              {option.FirstName} {option.LastName}
            </option>             
          ))
          :
          this.props.Userlista
          .filter(item=>{return isUndefined(this.props.allUsers)?!isEmpty(item.UserEmail) && parseInt(item.IamGhost) === 0:true})
          .map((option) => (
            <option key={option.id} value={option.id} disabled={isEmpty(option.UserEmail)}>
              {option.FirstName} {option.LastName}
            </option>
           ))
          :
          this.props.Userlista
          .filter(item=>{return isUndefined(this.props.allUsers)?!isEmpty(item.UserEmail) && parseInt(item.IamGhost) === 0:true})
          .map((option) => (
            <option key={option.id} value={option.id} disabled={isEmpty(option.UserEmail)}>
              {option.FirstName} {option.LastName}
            </option>
           ))
           :""}
          {  /*          
          !isEmpty(this.props.Userlista)?
          this.props.Userlista.filter(item=>{return !isEmpty(item.UserEmail)}).map((option) => (
            <option key={option.id} value={option.id}>
              {option.FirstName} {option.LastName}
            </option>
          )):""
        */
        }
            </TextField>  
            </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(SelectMedArbetare);